export const GET_CUSTOMERS_REQUESTED = 'GET_CUSTOMERS_REQUESTED'
export const GET_CUSTOMERS_SUCCEEDED = 'GET_CUSTOMERS_SUCCEEDED'
export const GET_CUSTOMERS_FAILED = 'GET_CUSTOMERS_FAILED'

export const SEARCH_CUSTOMER_SUCCEEDED = 'SEARCH_CUSTOMER_SUCCEEDED'

export const SELECT_CUSTOMER = 'SELECT_CUSTOMER'

export const UPDATE_TOGGLE = 'UPDATE_TOGGLE'
